import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Eye = ({
  className,
  color = '#00304D',
  width = 24,
  height = 24,
  state = 0,
}: SVGProps) => {
  // state 0 is off
  if (state === 0)
    return (
      <svg
        className={className}
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={width}
          height={height}
        >
          <rect width={width} height={height} fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_43_3982)">
          <path
            d="M19.8 22.6L15.6 18.45C15.0167 18.6333 14.4292 18.7708 13.8375 18.8625C13.2458 18.9542 12.6333 19 12 19C9.48333 19 7.24167 18.3042 5.275 16.9125C3.30833 15.5208 1.88333 13.7167 1 11.5C1.35 10.6167 1.79167 9.79584 2.325 9.0375C2.85833 8.27917 3.46667 7.6 4.15 7L1.4 4.2L2.8 2.8L21.2 21.2L19.8 22.6ZM12 16C12.1833 16 12.3542 15.9917 12.5125 15.975C12.6708 15.9583 12.8417 15.925 13.025 15.875L7.625 10.475C7.575 10.6583 7.54167 10.8292 7.525 10.9875C7.50833 11.1458 7.5 11.3167 7.5 11.5C7.5 12.75 7.9375 13.8125 8.8125 14.6875C9.6875 15.5625 10.75 16 12 16ZM19.3 16.45L16.125 13.3C16.2417 13.0167 16.3333 12.7292 16.4 12.4375C16.4667 12.1458 16.5 11.8333 16.5 11.5C16.5 10.25 16.0625 9.1875 15.1875 8.3125C14.3125 7.4375 13.25 7 12 7C11.6667 7 11.3542 7.03334 11.0625 7.1C10.7708 7.16667 10.4833 7.26667 10.2 7.4L7.65 4.85C8.33333 4.56667 9.03333 4.35417 9.75 4.2125C10.4667 4.07084 11.2167 4 12 4C14.5167 4 16.7583 4.69584 18.725 6.0875C20.6917 7.47917 22.1167 9.28334 23 11.5C22.6167 12.4833 22.1125 13.3958 21.4875 14.2375C20.8625 15.0792 20.1333 15.8167 19.3 16.45ZM14.675 11.85L11.675 8.85C12.1417 8.76667 12.5708 8.80417 12.9625 8.9625C13.3542 9.12084 13.6917 9.35 13.975 9.65C14.2583 9.95 14.4625 10.2958 14.5875 10.6875C14.7125 11.0792 14.7417 11.4667 14.675 11.85Z"
            fill={color}
          />
        </g>
      </svg>
    );

  // state 1 is on
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z"
        fill={color}
      />
    </svg>
  );
};
